import { OctGenerateForm } from '@oceantech/oceantech-ui';
import { useFormikContext } from 'formik';
import { Modal } from 'react-bootstrap';
import useFormio from 'src/app/hook/useFormio';
import { hasAuthority, KEY_AUTHORITIES } from 'src/app/modules/utils/Permission';

const FormThongTinChiDinh = ({
    defaultTermModel,
    expandForm,
}: any) => {
    const {values, errors, touched, setFieldValue } = useFormikContext<any>();
    const editable = hasAuthority(KEY_AUTHORITIES.CHUYEN_KHOA.FORM_CHI_DINH.EDIT);

    const { formJSON } = useFormio({
        code: defaultTermModel,
    });

    const { formJSON: prescriptionFormExpand } = useFormio({
        code: expandForm,
    });

    return (
        <Modal.Body className="dialog-body dialog-body-PTTT padding-3-20">
            <OctGenerateForm
                listFieldAuto={formJSON}
                setFieldValue={setFieldValue}
                values={values}
                modelID="formData"
                errors={errors}
                touched={touched}
                isView={!editable || values?.isViewModal}
            />
            {prescriptionFormExpand && (
                <OctGenerateForm
                    listFieldAuto={prescriptionFormExpand}
                    setFieldValue={setFieldValue}
                    values={values}
                    modelID="formData"
                    errors={errors}
                    touched={touched}
                    isView={!editable || values?.isViewModal}
                />
            )}
        </Modal.Body>
    );
};

export default FormThongTinChiDinh;
